import { TableItem } from './FeaturesComponents';

import exceedance from '../../../../../assets/analytics/exceedance_get_started.png';
import extremeValues from '../../../../../assets/analytics/extreme_values_get_started.png';
import histogram from '../../../../../assets/analytics/histogram_get_started.png';
import rosePlot from '../../../../../assets/analytics/rose_plot_get_started.png';
import scatterPlot from '../../../../../assets/analytics/scatter_plot_get_started.png';
import scatterTable from '../../../../../assets/analytics/scatter_table_get_started.png';
import statistics from '../../../../../assets/analytics/statistics_get_started.png';
import tidalLevels from '../../../../../assets/analytics/tidal_levels_get_started.png';
import timeSeriesData from '../../../../../assets/analytics/timeseries_get_started.png';
import waveSpectraSpectrograms from '../../../../../assets/analytics/wave_spectra_get_started_1.png';
import waveSpectraPolar from '../../../../../assets/analytics/wave_spectra_get_started_2.png';
import persistence from '../../../../../assets/analytics/weather_windows_get_started.png';

import extremeValuesFile from '../../../../../assets/analytics/Example_Extreme_Values_EVA.xlsx';
import normalSeaStatesFile from '../../../../../assets/analytics/Example_Normal_Sea_States_NSS.xlsx';

export const analyticsTable: TableItem[] = [
  {
    text: '1. Time Series',
    image: {
      src: timeSeriesData,
      alt: '',
    },
  },
  {
    text: '2. Statistics',
    image: {
      src: statistics,
      alt: '',
    },
  },
  {
    text: '3. Tidal levels',
    image: {
      src: tidalLevels,
      alt: '',
    },
  },
  {
    text: '4. Scatter plot',
    image: {
      src: scatterPlot,
      alt: '',
    },
  },
  {
    text: '5. Scatter table',
    image: {
      src: scatterTable,
      alt: '',
    },
  },
  {
    text: '6. Rose plot',
    image: {
      src: rosePlot,
      alt: '',
    },
  },
  {
    text: '7. Exceedance',
    image: {
      src: exceedance,
      alt: '',
    },
  },
  {
    text: '8. Histogram (Weibull fit)',
    image: {
      src: histogram,
      alt: '',
    },
  },
  {
    text: '9. Persistence (Weather windows)',
    image: {
      src: persistence,
      alt: '',
    },
  },
  {
    text: '10. Extreme values (EVA)',
    image: {
      src: extremeValues,
      alt: '',
    },
  },
  {
    text: '11. Wave Spectra',
    image: [
      {
        src: waveSpectraSpectrograms,
        alt: '',
      },
      {
        src: waveSpectraPolar,
        alt: '',
      },
    ],
  },
];

export const preProcessedAnalyticsTable: TableItem[] = [
  {
    text: '1. Normal Sea states (NSS)',
    link: {
      text: 'Normal Sea states (NSS).xlsx',
      href: normalSeaStatesFile,
    },
    type: 'file',
  },
  {
    text: '2. Extreme Values (EVA)',
    link: {
      text: 'Extreme Values (EVA).xlsx',
      href: extremeValuesFile,
    },
    type: 'file',
  },
];
